module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "img5",
      "src": "images/img5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Members of NIWV District of Columbia Camp No. 5 pose with President Calvin Coolidge on the White House lawn, 1928. Left to right, Evan D. Lewis, A. V. Dummel, G. A. Scheader, Jerome Lawler, Paul Schneider, C.W. Crawford, the President, J. J. Murphy, Henry McDonnell, and C. T. Edwards. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Editor's collection")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27b19ffe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndianWarVeterans_introduction7.vue
// module id = 99
// module chunks = 0